import { ReportDailyResultImg } from "@/pages/common/report/WebReport2/commons";
import { Typography } from "@mui/material";
import HelpButton from "../HelpButton";
import CriterionHelpDialogTableSections from "./commons/CriterionHelpDialogTableSections";

export default function QuantityCriterionHelpDialog({
  recommendedSleepTimeLow,
  recommendedSleepTimeHigh,
  appropriateSleepTimeLow,
  appropriateSleepTimeHigh,
  ageRange,
}: {
  recommendedSleepTimeLow: number;
  recommendedSleepTimeHigh: number;
  appropriateSleepTimeLow: number;
  appropriateSleepTimeHigh: number;
  ageRange: string;
}) {
  return (
    <HelpButton
      dialogTitle="睡眠の長さの判定基準"
      dialogProps={{ fullWidth: true }}
      iconSx={{
        height: "16px",
        width: "16px",
        color: "#A3A3A3",
        marginLeft: "4px",
      }}
    >
      <CriterionHelpDialogTableSections
        data={[
          {
            title: "日別判定の基準",
            table: {
              head: ["睡眠時間", "判定"],
              body: [
                {
                  label: `${recommendedSleepTimeLow}～${recommendedSleepTimeHigh}時間`,
                  data: [[<ReportDailyResultImg type={3} />]],
                },
                {
                  label: `${appropriateSleepTimeLow}～${recommendedSleepTimeLow}時間、${recommendedSleepTimeHigh}～${appropriateSleepTimeHigh}時間`,
                  data: [[<ReportDailyResultImg type={2} />]],
                },
                {
                  label: `${appropriateSleepTimeLow}時間未満、${appropriateSleepTimeHigh}時間超`,
                  data: [[<ReportDailyResultImg type={1} />]],
                },
              ],
            },
            remarks: [`※対象者年齢：${ageRange}の場合`],
          },
          {
            title: "睡眠の長さ判定の基準",
            table: {
              head: [
                <Typography variant="subtitle2">
                  <ReportDailyResultImg type={3} style={{ paddingRight: 1 }} />
                  の日数
                </Typography>,
                <Typography variant="subtitle2">
                  <ReportDailyResultImg type={1} style={{ paddingRight: 1 }} />
                  の日数
                </Typography>,
                "判定",
              ],
              body: [
                {
                  label: "5日以上",
                  data: [
                    ["なし", "良好"],
                    ["1～2日", "注意"],
                  ],
                },
                {
                  label: "4日以下",
                  data: [
                    ["0～2日", "注意"],
                    ["3日以上", "警戒"],
                  ],
                },
              ],
            },
            remarks: [
              "※測定日数が7日間の場合",
              "※測定日数が3日以下の場合は判定不能",
            ],
          },
        ]}
      />
    </HelpButton>
  );
}
